import { useGetMessageTemplatesQuery, FullMessageTemplateFragment, MessageTemplateType } from 'shared/types/graphql';
import { GraphQLFetchPolicies } from 'shared/enums/GraphQLFetchPolicies';

const useMessageTemplates = ({
  clinicId,
  isImpersonating,
}: {
  clinicId: string;
  isImpersonating: boolean;
}): { messageTemplates: FullMessageTemplateFragment[] | null | undefined } => {
  const { data: messageTemplatesData } = useGetMessageTemplatesQuery({
    variables: {
      clinicId: clinicId ?? '',
      types: isImpersonating
        ? [MessageTemplateType.Default, MessageTemplateType.CareCreditPreapproval]
        : [MessageTemplateType.Default],
    },
    skip: !clinicId,
    fetchPolicy: GraphQLFetchPolicies.CacheAndNetwork,
  });

  return { messageTemplates: messageTemplatesData?.findManyMessageTemplate };
};

export default useMessageTemplates;
